module.exports = __webpack_public_path__ + "img/shadow1.f05395fd.png";